import { richTextResolver } from '@storyblok/richtext';
import type { StoryblokRichTextNode } from '@storyblok/richtext';
import { computed, toValue } from 'vue';
import type { MaybeRefOrGetter } from 'vue';

export function useHeroComponentContent(
    blok: MaybeRefOrGetter<HeroComponentStoryblok | ProductOfTheMonthHeroStoryblok>
) {
    const heroBlok = computed(() => toValue(blok));
    const headlineContent = computed(() =>
        heroBlok.value.headline ? richTextResolver().render(heroBlok.value.headline as StoryblokRichTextNode) : ''
    );
    const asset = computed<StoryblokAsset | undefined>(() => heroBlok.value.asset);
    const mediaSrc = computed(() => asset.value?.filename ?? '');
    const mediaAlt = computed(() => asset.value?.alt ?? asset.value?.title ?? 'Hero Media');
    const mediaContentType = computed(() => asset.value?.content_type ?? '');

    return {
        headlineContent,
        asset,
        mediaSrc,
        mediaAlt,
        mediaContentType
    };
}
